<template>
  <div class="operator-notice" :class="`operator-notice--${variant}`" role="alert">
    <div class="operator-notice__icon">
      <feather-icon :icon="icon" size="22" />
    </div>
    <div class="operator-notice__body">
      <strong class="operator-notice__title">{{ title }}</strong>
      <span class="operator-notice__text">{{ text }}</span>
      <div v-if="$slots.default" class="operator-notice__actions">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
// Cartão de aviso fixo no canto da tela. Sobe para o <body> ao montar, porque a
// barra superior onde ele é declarado cria um contexto próprio de posicionamento.
export default {
  props: {
    variant: { type: String, default: "warning" },
    icon: { type: String, default: "AlertCircleIcon" },
    title: { type: String, required: true },
    text: { type: String, default: "" },
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  // Movido para o <body>, o cartão sai da árvore do Vue: se o pai for removido (ex.: o
  // PauseControl some junto), o Vue não o encontra e o aviso ficaria preso na tela.
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) this.$el.parentNode.removeChild(this.$el);
  },
};
</script>

<style scoped>
.operator-notice {
  position: fixed;
  top: 84px;
  right: 24px;
  z-index: 1060;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  width: 340px;
  max-width: calc(100vw - 32px);
  padding: 14px 16px;
  border-radius: 10px;
  border-left: 5px solid var(--notice);
  background: #fff;
  color: #3d3d3d;
  box-shadow: 0 8px 28px rgba(34, 41, 47, 0.25);
  animation: notice-in 0.25s ease-out;
}

.operator-notice--warning {
  --notice: #ff9f43;
}

.operator-notice--danger {
  --notice: #ea5455;
}

.operator-notice__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--notice);
  color: #fff;
}

.operator-notice--danger .operator-notice__icon {
  animation: notice-pulse 1.4s ease-in-out infinite;
}

.operator-notice__body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.operator-notice__title {
  color: var(--notice);
  font-size: 1rem;
}

.operator-notice__text {
  font-size: 0.9rem;
  line-height: 1.35;
}

.operator-notice__actions {
  margin-top: 8px;
}

@keyframes notice-in {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
}

@keyframes notice-pulse {
  50% {
    box-shadow: 0 0 0 7px rgba(234, 84, 85, 0.3);
  }
}

@media (prefers-reduced-motion: reduce) {
  .operator-notice,
  .operator-notice--danger .operator-notice__icon {
    animation: none;
  }
}
</style>
